@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../constants/spacing.module.less';

.drawer-main-content {
  max-width: 1200px;
  width: 100%;
  padding: @space-16 @space-16;
  margin: @space-16 0;
  align-self: center;
  background-color: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  gap: @space-24;
  font-size: 14px;
}

.drawer-content-header {
  padding: @space-8 @space-0 @space-16;
  font-weight: 500;
}

.form-section {
  padding-top: @space-24;
}

.form-row {
  align-items: flex-end;
  gap: @space-16;
}

.form-field {
  gap: @space-4;

  &:nth-child(1) .number-input {
    width: 100px;
  }

  &:nth-child(3) .number-input {
    width: 150px;
  }
}

.number-input {
  border-color: var(--grey-800);
}

.text-input input {
  border-color: var(--grey-800);
}

.generate-button {
  align-self: end;
}

.table-section {
  margin-top: @space-16;
  padding-top: @space-16;
  border-top: 1px solid var(--grey-300);
}

.add-single-section {
  margin: @space-16 @space-0;
}

.add-single-button {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.plus-icon {
  width: 12px;
  height: 12px;
}

.banner {
  align-self: flex-start;
}
